<div id="demo2"></div>
<!-- <div class="UNFAPP-score-whitetbx UNFAPP-equalizer-box data-box">
    <div class="row justify-content-between">
        <div class="col-auto">
            <div class="UNFAPP-equalizer-data">
                <span>Score :</span>
                <label>{{testdata?.outOfScore}}</label>
            </div>
        </div>
        <div class="col-auto">
            <div class="UNFAPP-equalizer-data">
                <span>Time :</span>
                <label>{{testdata?.totaltimespentinhrs}}</label>
            </div>
        </div>
        <div class="col-auto" *ngIf="testdata?.rank">
            <div class="UNFAPP-equalizer-data">
                <span>Rank :</span>
                <label>{{testdata?.rank}}</label>
            </div>
        </div>
        <div class="col-auto">
            <div class="UNFAPP-equalizer-data">
                <span>Percentage :</span>
                <label>{{testdata?.percentage}}%</label>
            </div>
        </div>
        <div class="col-auto">
            <div class="UNFAPP-equalizer-data">
                <span>Accuracy<div class="UNFAPP-c-tooltip"><img src="assets/img/tooltip-info-icon.svg" />
                    <div class="UNFAPP-c-tooltip-box accuracy">
                        <div class="UNFAPP-acurcy-toltip-innr">
                            <div class="UNFAPP-acry-txt">Accuracy = </div>
                            <div>
                                <div class="UNFAPP-acry-txt">No. of correct answers</div>
                                <hr>
                                <div class="UNFAPP-acry-txt">No. of attempted questions</div>
                            </div>
                        </div>
                    </div>
                </div> :</span>
                <label>{{testdata?.accuracy}}%</label>
            </div>
        </div>
        <div class="col-auto">
            <div class="UNFAPP-equalizer-data">
                <span>Time/ Question :</span>
                <label>{{testdata?.averageTimePerQuestion}}</label>
            </div>
        </div>
        
    </div>
</div> -->